<template>
    <v-app id="app">
        <app-bar />
        <start />
        <app-footer />
    </v-app>
</template>
<script>
import AppBar from '@/components/AppBar'
import AppFooter from '@/components/AppFooter'
import Start from '@/components/Start'
export default {
    name: 'App',
    components: {
        AppBar,
        AppFooter,
        Start
    },
    data(){
        return {

        }
    }
}
</script>
<style scoped lang="scss">
@import "@/assets/css/palettes.scss";
@import "@/assets/css/extends.scss";
div#app {
    // font-size: 16px;
    font-family: "proxima-nova", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: palette(Grey, 800);
    min-height: 100vh;

    background-image: url(./../assets/backslant-home-top.svg);
    background-size: cover;
}
</style>